module.exports = __webpack_public_path__ + "media/images/athletes/4314-1c603b3987537684de9df9667bfcd456.png";